import { useEffect, useState } from "react";
import { GetColumnSearchProps } from "../../../../components/table/column-search";
import state from "../../../../config/valtio/store";
import API from "../../../../services/api-request";
import FilterMenu from "./filter-menu";
import { useSearchParams } from "react-router-dom";
import { Button, Col, Image, message, Row, Modal } from "antd";
import DynamicTable from "../../../../components/DynamicTable";
import { baseUrl } from "../../../../config/url-config";
import { ExclamationCircleFilled } from "@ant-design/icons";
import AddUsers from "./modal-add-user";
import EditUsers from "./modal-edit-user";

const { confirm } = Modal;

function Users() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [dataUsers, setDataUsers] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [optionsPrivilege, setOptionsPrivilege] = useState([]);

  // Add Modal Variable & Function
  const [showAdd, setShowAdd] = useState(false);
  const onShowAdd = (val) => {
    setShowAdd(val);
  };

  // Edit Modal Variable Function
  const [showEdit, setShowEdit] = useState(false);
  const onShowEdit = (val) => {
    setShowEdit(val);
  };

  // Fetch Data
  const getUsers = async (query) => {
    const queryString = new URLSearchParams(query).toString();
    state.LOADING = true;

    await API.Get(`user${query ? "?" + queryString : ""}`)
      .then((result) => {
        setDataUsers(result.data);
      })
      .catch((err) => {
        message.info("Failed Fetch Users Data!");
      });

    state.LOADING = false;
  };

  const getPrivilege = async () => {
    state.LOADING = true;

    await API.Get("privilege")
      .then((result) => {
        setOptionsPrivilege(
          result?.data
            ?.filter((e) => e?.name?.toLowerCase() !== "admin")
            .map((e) => ({ value: e.id, label: e.name }))
        );
      })
      .catch((err) => {
        message.info("Failed Fetch Privilege Data!");
      });

    state.LOADING = false;
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 250,
      sorter: (a, b) => {
        if (a.name === null || a.name === "-") return 1;
        if (b.name === null || b.name === "-") return -1;
        return a.name.localeCompare(b.name);
      },
      ...GetColumnSearchProps("name"),
    },
    {
      title: "Photo",
      dataIndex: "image",
      key: "image",
      width: 75,
      render: (_, { image }) => (
        <Image
          width={40}
          height={40}
          src={baseUrl + "/" + image}
          fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi  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"
        />
      ),
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      width: 250,
      sorter: (a, b) => {
        if (a.username === null || a.username === "-") return 1;
        if (b.username === null || b.username === "-") return -1;
        return a.username.localeCompare(b.username);
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 250,
      sorter: (a, b) => {
        if (a.email === null || a.email === "-") return 1;
        if (b.email === null || b.email === "-") return -1;
        return a.email.localeCompare(b.email);
      },
    },
    {
      title: "Privilege",
      dataIndex: "privilege",
      key: "privilege",
      sorter: (a, b) => {
        if (a.privilege?.name === null || a.privilege?.name === "-") return 1;
        if (b.privilege?.name === null || b.privilege?.name === "-") return -1;
        return a.privilege?.name.localeCompare(b.privilege?.name);
      },
      width: 250,
      render: (privilege) => {
        if (privilege?.name === null || privilege?.name === "-") {
          return "-";
        } else {
          return privilege?.name;
        }
      },
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      render: (data) => {
        return (
          <Row align="middle" gutter={[8, 8]}>
            <Col>
              <Button
                type="primary"
                onClick={() => {
                  setSelectedData({ ...data });
                  onShowEdit(true);
                }}
              >
                Edit
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm(data);
                }}
              >
                Delete
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  // Table Function
  // const onSelectedData = (val) => {
  //   setSelectedData(val);
  // };

  // Filter Function
  const onSearch = async (value) => {
    updateSearchParam("name", value || null);
  };

  const onClear = async (val) => {
    const query = Object.fromEntries([...searchParams.entries()]);
    getUsers(query);
  };

  const updateSearchParam = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (value !== null) {
      newSearchParams.set(key, value);
    } else {
      newSearchParams.delete(key);
    }
    setSearchParams(newSearchParams);
  };

  // Delete Confirm
  const showDeleteConfirm = (data) => {
    confirm({
      title: `Delete ${data.name}`,
      icon: <ExclamationCircleFilled />,
      content: `Are you sure delete ${data.name}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        API.Delete(`user/id_user/${data.id}`)
          .then(() => {
            message.success("User has been deleted");
          })
          .catch((err) => {
            message.info("Failed delete user");
          })
          .finally(() => {
            const query = Object.fromEntries([...searchParams.entries()]);
            getUsers(query);
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  useEffect(() => {
    const query = Object.fromEntries([...searchParams.entries()]);
    getUsers(query);
    getPrivilege();
  }, []);

  useEffect(() => {
    const query = Object.fromEntries([...searchParams.entries()]);

    getUsers(query);
  }, [searchParams]);

  return (
    <>
      {/* Filter Menu */}
      <FilterMenu
        onSearch={onSearch}
        onClear={onClear}
        onGetUsers={getUsers}
        optionsPrivilege={optionsPrivilege}
        onShowAdd={onShowAdd}
      />

      {/* Users Table */}
      <DynamicTable data={dataUsers} columns={columns} />

      {/* Modal Add User */}
      <div
        style={{ display: "flex", justifyContent: "flex-end", margin: "8px 0" }}
      >
        <AddUsers
          showAdd={showAdd}
          onShowAdd={onShowAdd}
          onGetUsers={getUsers}
          optionsPrivilege={optionsPrivilege}
          setSearchParams={setSearchParams}
        />
      </div>

      {/* Modal Edit User */}
      <EditUsers
        showEdit={showEdit}
        onShowEdit={onShowEdit}
        onGetUsers={getUsers}
        selectedData={selectedData}
        optionsPrivilege={optionsPrivilege}
        setSearchParams={setSearchParams}
      />
    </>
  );
}

export default Users;
